import { useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { transform, get } from 'lodash';
import styled from 'styled-components';
import t from 'common/i18n';
import DropdownList from 'root/components/DropdownList/DropdownList';
import Button from 'root/components/Button';
import ResultsTopBar from 'root/components/ResultsTopBar';
import { selectConfigLanguage } from 'root/selectors';
import Breadcrumbs from '../Breadcrumbs';
import { ORDER_BY, SORT } from '../../data/consts';
import { selectIsLoading, selectIsNoResults } from '../../selectors/navigationSelectors';
import { selectOrderBy, selectSort, selectIsSearch } from '../../selectors';
import bindActions, { types as ats } from '../../actions';

import SVG_ICONS from '~/assets/icons/icons';

const { SET_SORT, SET_ORDER_BY } = ats;

const SortingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledDropdownList = styled(DropdownList)`
  width: 150px;
`;

export const TopBar = ({ sort, orderBy, isLoading, noResults, isSearch, lang, actions }) => {
  const orderByEntries = useMemo(
    () =>
      transform(
        Object.values(ORDER_BY),
        (acc, val) => {
          acc[val] = t(`google_drive.${val}`);
        },
        {}
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lang]
  );

  const isControlsDisabled = isLoading || noResults || isSearch;

  const orderByDisplay = useMemo(() => Object.values(orderByEntries), [orderByEntries]);

  const onOrderByChange = useCallback(
    (selectedValue) => {
      const orderByVal = get(
        transform(
          Object.entries(orderByEntries),
          (acc, [key, val]) => {
            if (selectedValue === val) {
              acc.push(key);
            }
          },
          []
        ),
        '[0]',
        ''
      );

      actions[SET_ORDER_BY](orderByVal);
    },
    [orderByEntries, actions]
  );

  const onClickSort = useCallback(() => {
    actions[SET_SORT](sort === SORT.DESC ? SORT.ASC : SORT.DESC);
  }, [actions, sort]);

  return (
    <ResultsTopBar className="justify-between">
      <Breadcrumbs />
      {!isSearch && (
        <SortingWrapper>
          <StyledDropdownList
            data-test="order-by-dropdown"
            items={orderByDisplay}
            selectedItem={orderByEntries[orderBy]}
            onChange={onOrderByChange}
            disabled={isControlsDisabled}
          />
          <Button
            icon={sort === SORT.ASC ? SVG_ICONS.ARROW_UP : SVG_ICONS.ARROW_DOWN}
            iconSize="lg"
            textColorName="menu-icons"
            disabled={isLoading}
            onClick={onClickSort}
          />
        </SortingWrapper>
      )}
    </ResultsTopBar>
  );
};

const mapStateToProps = (state) => ({
  sort: selectSort(state),
  orderBy: selectOrderBy(state),
  isLoading: selectIsLoading(state),
  noResults: selectIsNoResults(state),
  isSearch: selectIsSearch(state),
  lang: selectConfigLanguage(state),
});

export default connect(mapStateToProps, (dispatch) => ({
  actions: bindActions(dispatch),
}))(TopBar);
